import { render, staticRenderFns } from "./SignatureSafePaymentSection.vue?vue&type=template&id=1a71a8e2"
import script from "./SignatureSafePaymentSection.vue?vue&type=script&lang=js"
export * from "./SignatureSafePaymentSection.vue?vue&type=script&lang=js"
import style0 from "./SignatureSafePaymentSection.vue?vue&type=style&index=0&id=1a71a8e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports